import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  CheckCircle,
  Clock,
  Pulse,
  WarningCircle
} from '@phosphor-icons/react';
const Status = () => {
  const services = [
    { name: 'Platform', status: 'operational', uptime: '99.99%' },
    { name: 'Voice Agents', status: 'operational', uptime: '99.95%' },
    { name: 'API', status: 'operational', uptime: '99.99%' },
    { name: 'Agent Marketplace', status: 'operational', uptime: '99.99%' },
    { name: 'Authentication', status: 'operational', uptime: '99.99%' },
    { name: 'Webhooks', status: 'operational', uptime: '99.90%' }
  ];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'operational': return <CheckCircle size={18} className="text-[#14F195]" />;
      case 'degraded': return <WarningCircle size={18} className="text-[#F59E0B]" />;
      case 'outage': return <WarningCircle size={18} className="text-[#EF4444]" />;
      default: return <Clock size={18} className="text-[#718096]" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'operational': return 'Operational';
      case 'degraded': return 'Degraded Performance';
      case 'outage': return 'Major Outage';
      default: return 'Checking...';
    }
  };

  return (
    <>
      <SEO title="System Status - Man & Machine" description="Check the current status of Man & Machine services." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#14F195]/10 via-transparent to-[#6366F1]/10" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#14F195]/10 border border-[#14F195]/20 text-[#14F195] text-sm font-medium mb-6">
                <Pulse size={16} />
                All Systems Operational
              </div>
              
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                System Status
              </h1>
              
              <p className="text-lg text-[#A0AEC0]">
                Current status of Man & Machine services.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-3xl mx-auto px-6 pb-20">
          <div className="glass rounded-2xl divide-y divide-[rgba(255,255,255,0.1)]">
            {services.map((service, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: i * 0.05 }}
                className="flex items-center justify-between p-4"
              >
                <div className="flex items-center gap-3">
                  {getStatusIcon(service.status)}
                  <span className="text-white font-medium">{service.name}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-[#718096] text-sm">{service.uptime} uptime</span>
                  <span className={`text-sm ${
                    service.status === 'operational' ? 'text-[#14F195]' :
                    service.status === 'degraded' ? 'text-[#F59E0B]' : 'text-[#EF4444]'
                  }`}>
                    {getStatusText(service.status)}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mt-8 text-center text-[#718096] text-sm">
            Last updated: {new Date().toLocaleString()}
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default Status;